export const getLocalePrice = (price: number | bigint): string =>
  `¥ ${price.toLocaleString('ja-JP')}`;
